import React from "react";
import ReactDOM from "react-dom";
import { Router } from "@reach/router";

import "normalize.css";
import "./assets/styles.css";

import Splash from "./components/Splash";
import HowToPlay from "./components/HowToPlay";
import Play from "./components/Play";

// ========= APP =========
const App = () => {
	return (
		<Router basepath="/play/Brain_Trivia" >
			<Splash default />
			<HowToPlay path="how-to-play" />
			<Play path="play" />
		</Router>
	);
};

ReactDOM.render(<App />, document.querySelector(`#app`));
